define(["exports", "react", "react-intl-universal", "styled-components", "../../atoms", "../../themes", "../../utils", "./CvProviderContext"], function (_exports, _react, _reactIntlUniversal, _styledComponents, _atoms, _themes, _utils, _CvProviderContext) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireWildcard(_react);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  _styledComponents = _interopRequireWildcard(_styledComponents);

  var TextProfile = _styledComponents.default.div.withConfig({
    displayName: "Profile__TextProfile",
    componentId: "sc-1ldb2pb-0"
  })(["border-bottom:solid 1px ", ";position:relative;margin:0 0 40px;h2{display:none;margin:0 0 24px;}@media print{border-top:solid 1px ", ";margin-bottom:24px;h2{display:block;margin-bottom:16px;margin-top:24px;}}p{display:block;display:-webkit-box;height:40px;margin:0 0 24px 0;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical;}", ""], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.lightGray;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.lightGray;
  }, function (_ref3) {
    var readMoreStyle = _ref3.readMoreStyle;
    return readMoreStyle && (0, _styledComponents.css)(["p{height:auto;overflow:visible;text-overflow:initial;-webkit-line-clamp:initial;}"]);
  });

  var SeeMore = _styledComponents.default.button.withConfig({
    displayName: "Profile__SeeMore",
    componentId: "sc-1ldb2pb-1"
  })(["background-color:transparent;border:0;bottom:-32px;color:", ";cursor:pointer;display:block;font-size:1.4em;font-weight:", ";overflow:hidden;position:absolute;text-align:center;width:100%;&:focus{", ";}"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.orange;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.font.semibold;
  }, _themes.focusBoxShadow);

  var Profile = function Profile(_ref6) {
    var profile = _ref6.profile;

    var _useState = (0, _react.useState)(false),
        readMore = _useState[0],
        setReadMore = _useState[1];

    var _useState2 = (0, _react.useState)(false),
        shouldRenderReadMoreButton = _useState2[0],
        setShouldRenderReadMoreButton = _useState2[1];

    var _useContext = (0, _react.useContext)(_CvProviderContext.CvProviderContext),
        readMoreFromPrint = _useContext.readMoreFromPrint,
        shouldHideButtonOnPrint = _useContext.shouldHideButtonOnPrint,
        setShouldHideButtonOnPrint = _useContext.setShouldHideButtonOnPrint;

    var size = (0, _utils.useWindowSize)();
    var textRef = (0, _react.useRef)();
    (0, _react.useEffect)(function () {
      var _textRef$current, _textRef$current2;

      setReadMore(false);
      setShouldRenderReadMoreButton(((_textRef$current = textRef.current) == null ? void 0 : _textRef$current.scrollHeight) > ((_textRef$current2 = textRef.current) == null ? void 0 : _textRef$current2.offsetHeight));
    }, [size]);
    (0, _react.useEffect)(function () {
      setTimeout(function () {
        var _textRef$current3, _textRef$current4;

        setShouldRenderReadMoreButton(((_textRef$current3 = textRef.current) == null ? void 0 : _textRef$current3.scrollHeight) > ((_textRef$current4 = textRef.current) == null ? void 0 : _textRef$current4.offsetHeight));
      }, 0);
    }, []);
    (0, _react.useLayoutEffect)(function () {
      function handleBeforePrint() {
        setReadMore(true);
        setShouldHideButtonOnPrint(true);
      }

      function handleAfterPrint() {
        setReadMore(false);
        setShouldRenderReadMoreButton(textRef.current.scrollHeight > textRef.current.offsetHeight);
        setShouldHideButtonOnPrint(false);
      }

      window.addEventListener('beforeprint', handleBeforePrint);
      window.addEventListener('afterprint', handleAfterPrint);
      return function () {
        window.removeEventListener('beforeprint', handleBeforePrint);
        window.removeEventListener('afterprint', handleAfterPrint);
      };
    }, []);
    return /*#__PURE__*/_react.default.createElement(TextProfile, {
      readMoreStyle: readMore || readMoreFromPrint
    }, /*#__PURE__*/_react.default.createElement(_atoms.H2, null, _reactIntlUniversal.default.get('CURRICULUM.PERFIL.TITULO')), /*#__PURE__*/_react.default.createElement(_atoms.Small, null, /*#__PURE__*/_react.default.createElement("div", {
      ref: textRef
    }, /*#__PURE__*/_react.default.createElement(_atoms.FormatText, {
      texts: profile
    }))), shouldRenderReadMoreButton && !shouldHideButtonOnPrint && /*#__PURE__*/_react.default.createElement(SeeMore, {
      onClick: function onClick() {
        return setReadMore(!readMore);
      },
      "aria-label": readMore || readMoreFromPrint ? _reactIntlUniversal.default.get('CURRICULUM.PERFIL.VER_MENOS') : _reactIntlUniversal.default.get('CURRICULUM.PERFIL.VER_MAIS')
    }, readMore || readMoreFromPrint ? _reactIntlUniversal.default.get('CURRICULUM.PERFIL.VER_MENOS') : _reactIntlUniversal.default.get('CURRICULUM.PERFIL.VER_MAIS')));
  };

  Profile.defaultProps = {
    profile: ''
  };
  var _default = Profile;
  _exports.default = _default;
});